/** Splits a pathname into its non-empty segments (leading/trailing slashes are ignored). */
export function parsePathSegments(pathname: string): string[] {
  return pathname.split('/').filter(Boolean);
}
